if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      if (!variantId) return;

      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = '';
      }
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      const button = this.querySelector('button');
      if (button)
        button.addEventListener('click', (evt) => {
          document.querySelector('pickup-availability-drawer').show(evt.target);
        });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.bindCallButtons();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });

      this.querySelectorAll('.pickup-availability-variant:not(.out)').forEach((sizes) => {
        sizes.addEventListener('click', (ev) => {
          var variantUid = ev.currentTarget.getAttribute('data-variant-id');
          var variantTitle = ev.currentTarget.textContent.trim();
          const inputSize = document.querySelector('input[name="contact[size]"]');
          if (variantTitle && inputSize) {
            inputSize.value = variantTitle;
          }
          this.querySelector('.pickup-availability-variant.selected').classList.remove('selected');
          ev.currentTarget.classList.add('selected');
          this.reloadAvailabilityList(variantUid);
        });
      });

    }

    bindCallButtons() {
      this.querySelectorAll('.pickup-open-call').forEach((button) => {
        button.addEventListener('click', (ev) => {
          // Reset
          this.querySelector('.call__content--inner').innerHTML = '';

          const blockContainer = button.closest(".accordion__content");
          if (!blockContainer) return;

          const contentForCallBlock = blockContainer.querySelector(".content-for-call-block").innerHTML;
          const callContainer = this.querySelector(".call__content--inner");

          if (contentForCallBlock && callContainer) {
            callContainer.innerHTML = contentForCallBlock;
            callContainer.classList.remove("hidden"); // Si besoin de l'afficher
          }

          this.querySelector('.pickup-call')?.classList.add('open');
        });
      });

      this.querySelector('.pickup-call__back').addEventListener('click', (ev) => {
        this.querySelector('.pickup-call').classList.remove('open');
      });

      this.querySelectorAll('.pickup-open-be-called').forEach((button) => {
        button.addEventListener('click', (ev) => {
          //name="contact[shop]"
          const accordionTab = button.closest('accordion-tab');
          if (accordionTab) {
            const shopTitle = accordionTab.querySelector('.accordion__title')?.textContent.trim();
            const inputShop = document.querySelector('input[name="contact[shop]"]');

            if (shopTitle && inputShop) {
              inputShop.value = shopTitle;
            }
          }
          this.querySelector('.pickup-becalled').classList.add('open');
        });
      });

      this.querySelector('.pickup-becalled__back').addEventListener('click', (ev) => {
        this.querySelector('.pickup-becalled').classList.remove('open');
      });

      this.querySelector('.pickup-contact-result__back').addEventListener('click', (ev) => {
        this.querySelector('.pickup-contact-result').classList.remove('open');
      });
    }

    reloadAvailabilityList(variantId) {
      if (!variantId) return;

      let rootUrl = '/';
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.pickup-availability-list');
          const drawerMain = this.querySelector('.pickup-availability-list--outer');
          drawerMain.innerHTML = sectionInnerHTML.outerHTML;
          this.bindCallButtons();
        })
        .catch(() => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });

    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('pickup-availability--open');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      setScrollbarWidth();
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('pickup-availability--open');
      trapFocus(this);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get("contact_posted");

  if (contactPosted === "true") {
    setTimeout(() => {
      document.querySelector('#ShowPickupAvailabilityDrawer').click();
      document.querySelector('.pickup-contact-result').classList.add('open');
    }, 400);
  }
});